import React from "react";
import { useField } from "formik";
import { format } from "date-fns";
import TextField from "@mui/material/TextField";
import {DateTimePicker} from "@mui/x-date-pickers";
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from "@mui/x-date-pickers";
import FormHelperText from "@mui/material/FormHelperText";
import Typography from "@mui/material/Typography";
import FormInputShell from "./FormInputShell";
import { InputShell } from "./FormInputShell";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  menu: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  subLabel: {
    margin: 0,
    padding: 0,
    fontSize: 9,
    fontWeight: 600,
    color: theme.palette.common.black,
  },
  hideElement: {
    display: "none",
  },
  label: {
    margin: 0,
    padding: 0,
    fontSize: 16,
    // fontWeight: 600,
  },
  _label: {
    fontSize: "12px !important",
  },
  typography: {
    fontSize: 14,
    padding: 10,
    border: "1px solid grey",
    borderRadius: 5,
    color: theme.palette.common.grey,
  },
}));

const SimpleTimeDateInput = ({
  name,
  value,
  readOnly,
  onChange,
  removeBottomMargin,
  ...props
}) => {
  const classes = useStyles()
  return (
    <InputShell name={name} label={props.label} removeBottomMargin>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        {readOnly ? (
          <Typography className={classes.typography} variant="body1" gutterBottom>
            {format(new Date(props.readonlyvalue), "dd MMM, yyyy")}
          </Typography>
        ) : (
          <DateTimePicker
            value={new Date(value)}
            readOnly={readOnly}
            disabled={readOnly}
            onChange={onChange}
            slotProps={{
              textField: {
                style: { width: "100%" },
                InputProps: {
                  style: {
                    height: 38,
                    width: "100%",
                  },
                },
              },
            }}
            {...props as any}
          />
        )}
      </LocalizationProvider>
    </InputShell>
  );
};

const TimeDateInput = ({ label, readOnly, ...props }: any) => {
  const [field, meta, helper] = useField(props);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      {readOnly ? (
        <Typography variant="body1" gutterBottom>
          {format(new Date(field.value), "dd MMM, yyyy")}
        </Typography>
      ) : (
        <DateTimePicker
          autoOk
          fullWidth
          mask=""
          variant="inline"
          error={meta.touched && !!meta.error}
          inputVariant="outlined"
          // inputFormat="dd/MM/yyyy"
          readOnly={readOnly}
          disabled={readOnly}
          renderInput={(props) => (
            <TextField {...props} style={{ width: "100%" }} />
          )}
          InputProps={{
            style: {
              height: 38,
              width: "100%",
            },
          }}
          onClose={() => helper.setTouched(true)}
          {...field}
          {...props}
          onChange={(date) => {
            helper.setValue(date);
          }}
        />
      )}
      <FormHelperText error={meta.touched && !!meta.error}>
        {meta.touched && meta.error}
      </FormHelperText>
    </LocalizationProvider>
  );
};

const FormTimeDateInput = (props: any) => (
  <FormInputShell label={props.label} name={props.name}>
    <TimeDateInput {...props} />
  </FormInputShell>
);

FormTimeDateInput.propTypes = DateTimePicker.propTypes;

export default FormTimeDateInput;
export { TimeDateInput, SimpleTimeDateInput };
